import { getRailsClient } from "../client";

import { SiteSettings } from "./types/siteSettingTypes";
export interface SiteResponse {
  site: SiteSettings;
}

const SITE_SETTINGS = `/api/internal_api/v2/site`;

export const getSiteSettings = async (): Promise<SiteResponse | null> => {
  try {
    const { data } = await getRailsClient().get(SITE_SETTINGS);
    return data;
  } catch (error) {
    console.error("Error fetching site settings:", error);
    return null;
  }
};
